import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { hMacAjax } from 'grt-tool-lib-front';
import { getMessage } from './util';
import { baseURL } from '@/httpService/API';
let improveOrgList = `${baseURL}/grt-student-service/open/student/v1/student-invite/org/list`;
// data_source_type 1自定义  2平台数据源
const SelectForm = (props) => {
    let { setting = {}, updated, desc, field_type } = props,
        disabled = updated !== 0,
        [options, setOptions] = useState([]),
        //请求后端数据源接口
        getOptions = () => {
            hMacAjax.get(improveOrgList).then((res) => {
                if (res.success) {
                    let items = [];
                    for (let i = 0; i < res.data?.length; i++) {
                        let item = {
                            id: res.data[i]['id'],
                            name: res.data[i]['org_name']
                        };
                        items.push(item);
                    }
                    setOptions(items);
                }
            });
        };
    useEffect(() => {
        //props?.need_call_next_api 0|1 承培是用props.orgs的下拉数据 自培走原有逻辑
        if((props?.need_call_next_api === 0 || props?.need_call_next_api === 1) && props?.en_name === 'org_id'){
            let items = [];
            for (let i = 0; i <props.orgs?.length; i++) {
                let item = {
                    id: props.orgs[i]['id'],
                    name: props.orgs[i]['org_name']
                };
                items.push(item);
            }
            setOptions(items);
        }else{
            if(setting.data_source_type === 1) {
                let enabledOption = setting.options.filter((ele) => ele.enabled === true);
                return setOptions(enabledOption);
            }
            getOptions();
        }
    }, []);

    return (
        <Select
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            mode={setting.type === 'multiple' ? 'multiple' : ''}
            disabled={disabled}
            fieldNames={{ label: 'name', value: 'id' }}
            placeholder={desc || getMessage(field_type)}
            options={options}
            showSearch={setting?.data_source_type && setting?.data_source_type !== 1}
            listHeight={135}
            className={'grt-dynamic-select'}
            allowClear
        />
    );
};
export default SelectForm;
